
<div class="edit-role">
  <div class="modal edit-role-modal" style="position: absolute !important">
    <div class="modal-background" @click="closeModal" />
    <button class="modal-close is-large" @click="closeModal" />
    <div class="modal-card">
      <section class="modal-card-body">
        <ChangeDriverRole
          v-if="showChangeDriver"
          :role="role"
          @close="showChangeDriver = false"
          @changed="
            infoToast('Changed driver role!');
            closeModal();
          "
        />

        <p v-if="role && !showChangeDriver" class="header is-size-4">
          <span
            v-if="$store.getters.isSuperUser"
            class="button is-rounded is-grey is-outlined is-pulled-right"
            style="padding: 9px"
            @click="showChangeDriver = !showChangeDriver"
          >
            <i class="fa fa-pencil-alt has-text-success" />
          </span>
          {{ role.business.name }}
          <br />
          {{ role.workflow_name }} - {{ role.role_name }}
          <!-- {{ roleTitle }} -->
        </p>
        <div class="card" style="border-radius: 25px">
          <div class="card-content">
            <div class="content has-text-left">
              <p class="field-name">
                <span>{{ $t("profile.vehicle") }}</span>
                <span class="is-pulled-right">{{ $t("profile.color") }}</span>
              </p>
              <i class="fa fa-shuttle-van"></i>&nbsp;&nbsp;
              <span class="tag is-dark is-medium" @click="editLicensePlate">{{
                vehicleNumberFallback
              }}</span>
              <span class="is-pulled-right">
                <swatches
                  style="
                    display: inline-block;
                    border: 2px black solid;
                    border-radius: 35%;
                    height: 36px;
                  "
                  v-model="color"
                  max-height="200"
                  swatch-size="32"
                  :trigger-style="{ width: '32px', height: '32px' }"
                  popover-to="left"
                  @close="updateRole"
                />
              </span>

              <input
                type="file"
                ref="file"
                style="display: none"
                accept="image/png,image/jpeg,image/jpg,image/bmp"
                @change="setVehiclePicAWS($event)"
              />

              <div class="is-flex" style="margin-top: 10px">
                <div style="flex: 1" />
                <figure class="image is-128x128">
                  <p class="field-name">{{ $t("profile.vehicle-pic") }}</p>
                  <img :src="imageURLFallback" @click="$refs.file.click()" />
                </figure>
                <div style="flex: 1" />
              </div>
            </div>
          </div>
          <div class="is-flex" style="gap: 8px">
            <button
              v-if="isSuperUser()"
              class="button is-info is-rounded is-outlined"
              @click="editDriverData"
            >
              Edit
            </button>
            <button
              class="button is-link is-rounded"
              style="flex-grow: 1"
              @click="submit"
            >
              {{ $t("submit") }}
            </button>
            <button
              v-if="isSuperUser()"
              class="button is-danger is-rounded is-outlined"
              @click="removeWorkerRole()"
            >
              Delete
            </button>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
